// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

declare var google;

export const environment = {
  production: false,
  // sitUrl:'http://localhost/propira_admin/api',
  sitUrl: 'https://project.imgglobal.in/propira/backend/api',
  fbId: "5494001317355826",
  gtagId: "UA-187473572-1",
  // sitUrl: 'http://192.168.1.11/propira_admin/api'
  norteastLatLongFirst: 27.499874,
  norteastLatLongSecond: 76.5542804,
  southwestLatLongFirst: 27.6727726,
  southwestLatLongSecond: 76.6965866,
  strictBounds: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mqolode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
